export default {"src":"/_next/static/media/icon_store_v2_cash_icon.96511cb0.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};